module.exports = __webpack_public_path__ + "static/media/tracking1.00352232.png";